<div>
    <adapt-link-person [imageOnly]="true"
                       [person]="userService.currentPerson$ | async"></adapt-link-person>
    <span>Add a comment...</span>
</div>
